@if (room) {
  @if (room.name) {
    <div>{{ room.name }}</div>
  }
  @if (room.address) {
    <div>{{ room.address }}</div>
  }
  @if (room.floor || room.room) {
    <div>
      @if (room.floor) {
        <span>{{ room.floor }}</span>
      }
      @if (room.room) {
        <span> Raum {{ room.room }}</span>
      }
    </div>
  }
  @if (online) {
    <div>(auch online)</div>
  }
}